export default __webpack_public_path__ + "static/media/Celo_Symbol_Onyx.3c329c78.svg";